import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconPredictedRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M16 29.333c7.364 0 13.333-5.97 13.333-13.333S23.363 2.667 16 2.667 2.667 8.636 2.667 16 8.637 29.333 16 29.333m5.149-16.351a5.14 5.14 0 0 1-2.142 4.18c-.194.139-.23.272-.23.317v1.428a1 1 0 0 1-1 1h-3.555a1 1 0 0 1-1-1V17.48c0-.045-.034-.178-.228-.318a5.149 5.149 0 1 1 8.155-4.18m-3.373 8.185a1 1 0 1 1 0 2h-3.554a1 1 0 1 1 0-2z" clipRule="evenodd" /></svg>;
export default SvgIconPredictedRoundedFilled;